import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import NormalBtn from '../common/button/NormalBtn';


const EsItemNoneBlock = styled.div`
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    height: 180px;
    magin-bottom: 200px;
    //border-bottom:1px solid #cccccc;
    font-size: 16px;
    color: #666666;
`;

const EsItemNoneGuideBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 15px;
`;


/**
 * 견적 없거나 비로그인 상태일때 표시
 */
const EsItemNone = ({ curIdx }) => {

    const history = useHistory();

    const handlerBtnClick = () => {
        history.push('/br')
    }

    const getIcon = () => {
        if (curIdx === 0) {
            return "🤭";
        } else {
            return "🤭"
        }
    }

    const getMsg = () => {
        if (curIdx === 0) {
            return "앗! 진행중인 견적서가 없어요.";
        } else {
            return "주문내역이 없어요:-("
        }
    }

    const getBtn = () => {
        if (curIdx === 0) {
            return (<NormalBtn text="상품 담으러 가기"
                width="170px" height="40px" borderRadius="20px"
                fontWeight="300" fontSize="16px"
                minWidth="170px" onClick={handlerBtnClick} />);
        } else {
            return "";
        }
    }

    return (
        <EsItemNoneBlock>
            <EsItemNoneGuideBlock>
                <p>{getIcon()} </p>
            </EsItemNoneGuideBlock>
            <EsItemNoneGuideBlock>
                <p>{getMsg()} </p>
            </EsItemNoneGuideBlock>
            <EsItemNoneGuideBlock>
                {/* {getBtn()} */}
            </EsItemNoneGuideBlock>
        </EsItemNoneBlock>
    );
};

export default EsItemNone;
